import React, { Component } from 'react';
import './AboutMe.css';
import Col3Blur from './Col3ablur.png';
import portrait from './portrait.jpg';
import mountain2 from './Mountain2.png';
import iceland from './Iceland2.png';
import iceland3 from './iceland3.png';
import iceland4 from './iceland4.jpg';

class AboutMe extends Component {


  constructor(props) {
    super(props);
    console.log(props);
    this.checkSize = this.checkSize.bind(this);
  }

  checkSize(){
    if (window.innerWidth < 650){
      return true;
    }
    return false;
  }

  render() {
    var variant;
    if(this.props.on){
     variant = 'BgImage2';
    } else {
     variant = 'BgImage3';
    }

    var variant2;
    var variant3;
    var variant4;
    var variant5;
  var variant6;
  var variant7;
  var variant3a;
  var variant3b;
  var variant3c;
  var variant3d;
    if (this.checkSize()){
      variant2 = "pimage2";
      variant3 = "t1b";
      variant3a = "t11b";
      variant3b = "t12b";
      variant3c = "t13b";
      variant3d = "t14b";
      variant4 = "pimage3";
      variant5 = "pimage5";
      variant6 = "pimage7";
      variant7 = "pimage9";
    }
    else{
      variant2 = "pimage";
      variant3 = "t1";
      variant3a = "t11";
      variant3b = "t12";
      variant3c = "t13";
      variant3d = "t14";
      variant4 = "pimage4";
      variant5 ="pimage6";
      variant6 = "pimage8";
      variant7 = "pimage10";
    }
    if (!this.props.show){
      console.log('hit1');
      return null;
    }
    else{
    return (
        <div>
            <img id={variant} src={Col3Blur} alt="None"/>
            <img id={variant2} src={portrait} alt="None"/>
            <div id={variant3}>    My desire to fill space or finding some completion of it has been <br/>an old obsession of mine.Could <br/>not say that I am a master, 
             yet I <br/>find myself intrinsically drawn to <br/>the aesthetic 
             of a design space.  </div>
             <div id={variant3a}>   Everything is expressed through relationship. Colour can exist only through other colours, dimension through other dimensions, position through other positions that oppose them. That is why I regard relationship as the principal thing. -Piet Mondrian 
</div>
             <div id={variant3b}>   The problem with introspection is that it has no end.  -Philip K Dick  </div>
             <div id={variant3c}>   I can't go back to yesterday because I was a different person then.  -Lewis Carroll </div>
             <div id={variant3d}>There are dark shadows on the earth, but its lights are stronger in the contrast. -Charles Dickens</div>
             <img id={variant4} src={mountain2} alt="None"/>
             <img id={variant5} src={iceland} alt="None"/>
             <img id={variant6} src={iceland3} alt="None"/>
             <img id={variant7} src={iceland4} alt="None"/>
             <br/><br/>
        </div>
      );
    }
  }
}

export default AboutMe;


// WEBPACK FOOTER //
// ./src/AboutMe.js